export const OPTANON_COOKIE = 'OptanonConsent';

export const ESSENTIAL = 'C0001';
export const PERFORMANCE = 'C0002';
export const FUNCTIONAL = 'C0003';
export const TRACKING = 'C0004';

export const ENABLE_COOKIE_PARAM = ':1';
export const DISABLE_COOKIE_PARAM = ':0';
